import * as React from 'react';
import styled from 'styled-components';
import { Dropdown, IDropdownProps, IDropdownOption } from '../../dropdown';
import { SecondaryButton } from '../../button';
import { getYearOptions } from '../utils';
import { selectThemeSemantics } from '../../../styling/theming';

export interface ICalendarToolbarProps {
    todayButtonLabel?: string;
    showTodayButton?: boolean;
    selectedYear: number;
    startYear?: number;
    endYear?: number;
    onTodayClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onYearChange: (selectedKeys: React.Key[], selectedValues: IDropdownOption[]) => void;
}

const CalendarToolbarWrapper = styled.div.attrs({
    className: 'ap-calender-toolbarWrapper'
})`
    height: 35px;
    position: relative;
    margin-bottom: ${selectThemeSemantics(({ gap }) => gap.xl)};
`;

const YearDropdown = styled(Dropdown as React.ComponentType<IDropdownProps>)`
    position: absolute;
    left: 0;
    top: 0;
    min-width: 100px;
`;

const TodayButton = styled(SecondaryButton)`
    position: absolute;
    right: 0;
    top: 0;
    padding: 0;
`;

export function CalendarToolbar(props: ICalendarToolbarProps) {
    const { selectedYear, onYearChange, startYear, endYear, showTodayButton, todayButtonLabel, onTodayClick } = props;
    return (
        <CalendarToolbarWrapper>
            <YearDropdown hideSearchIcon items={getYearOptions(startYear, endYear)} selectedKeys={selectedYear} onValueChange={onYearChange} />
            {showTodayButton ? <TodayButton title={todayButtonLabel} type="button" label={todayButtonLabel} onClick={onTodayClick} /> : null}
        </CalendarToolbarWrapper>
    );
}
